import { ProductData } from 'utils/types';
import { Box } from '@mui/material';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { StyledSubProduct } from '../styles';

export const SubProduct: React.FC<{
  subProduct: ProductData;
}> = ({ subProduct }) => {
  return (
    <StyledSubProduct className="sub-product">
      <Box className="product-info">
        {subProduct.images.product && (
          <div className="product-img">
            <img
              className="image"
              src={subProduct.images.product}
              alt="product"
            />
          </div>
        )}
        <div className="price-container">
          {subProduct.quantityDisplay && (
            <div className="quantity-container">
              <AutoTextSize
                as="div"
                mode="oneline"
                maxFontSizePx={14}
                minFontSizePx={6}
                className="quantity-container__value"
              >
                {subProduct.quantityDisplay}
              </AutoTextSize>
            </div>
          )}
        </div>
      </Box>
    </StyledSubProduct>
  );
};
